import papaparse from 'papaparse';

export default class {

    $get () {
        return papaparse;
    }

}



// WEBPACK FOOTER //
// ./src/app/providers/papaparse/index.js